import { Injectable } from '@angular/core';

import { WindowLocation, WindowShim } from './window-shim';

declare const window: WindowShim;

@Injectable()
export class WindowShimService {
  get window(): WindowShim {
    return window;
  }

  get location(): WindowLocation {
    return this.window.location;
  }

  addEventListener(type: string, handler: (event: Event) => void): void {
    window.addEventListener(type, handler);
  }
}
